<template>
  <div>
    <b-row v-if="salesSettings">
      <b-col lg="6" md="6" sm="12">
        <legend>
          <strong>{{ $t('sales') }} {{ $t('settings') }}</strong>
        </legend>

        <b-form-group
          horizontal
          :label="$t('totalCommission')"
          label-for="totalCommission"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="salesSettings.totalCommission"
            mode="decimal"
            :minFractionDigits="1"
            :maxFractionDigits="5"
            :min="0"
            :max="100"
            :placeholder="$t('totalCommission')"
            suffix=" %"
            locale="de-DE"
            class="w-100"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="6" sm="12"> </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        <div class="button-bar">
          <div class="button-grid">
            <div class="alert-container">
              <b-alert show v-if="getFlashMessage.message" :variant="getFlashMessage.type">
                <span v-html="getFlashMessage.message" />
              </b-alert>
            </div>
            <div><Spinner class="spinner" v-if="isLoading" :size="25" /></div>
            <div>
              <b-button :disabled="isLoading" @click="saveSettings" variant="bg">{{
                $t('save')
              }}</b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import InputNumber from 'primevue/inputnumber';

export default {
  name: 'SettingsSales',
  components: {
    Spinner,
    InputNumber,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getFlashMessage', 'isLoading', 'getSalesSettings']),
    salesSettings() {
      return this.getSalesSettings;
    },
  },
  methods: {
    ...mapActions(['fetchSettingsByCategory', 'updateSettings']),

    async saveSettings() {
      try {
        const result = await this.updateSettings({
          category: 'SALES',
          settings: this.salesSettings,
        });
      } catch (error) {
        console.error('Error updating settings:', error);
      }
    },
  },
  async mounted() {
    try {
      const settings = await this.fetchSettingsByCategory('SALES');
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  },
};
</script>

<style scoped lang="scss">
.button-bar {
  .button-grid {
    display: flex;
    gap: 0.75rem;
    flex-flow: row wrap;
    align-items: right;
    justify-content: right;
    align-content: flex-end;
    background: #f5f5f5;
    padding: 1rem 1rem 0.75rem 1rem;
  }
}
</style>
